<div class="bg-white w-full h-full overflow-hidden">
    <div class="flex flex-col">
        <div class="py-3 mx-4 w-24 md:w-1/6">
            <img class="w-full" src="/assets/icon/assured-partner.png" alt="Assured Partners Logo" *ngIf="!isOrlandoMagicPage && !isCityNationalBankPage" />
            <img class="w-full" src="/assets/logos/orlando-magic-logo.png" alt="Orlando Magic Logo" *ngIf="isOrlandoMagicPage" />
            <img class="w-full" src="/assets/logos/city-national-bank.png" alt="City National Bank Logo" *ngIf="isCityNationalBankPage" />
         </div>
         <div class="flex flex-col items-center justify-center mt-6">
            <ng-container *ngIf="isEmployeePage || isContactFormPage; else nonEmployee">
                <div class="sm:mx-4">
                    <ng-container *ngIf="!trustedUrl">
                        <p class="text-black-800 font-inter-bold text-2xl text-center py-4"> {{ title }} </p>
                        <p class="text-black-800 font-inter text-xl text-center pb-4 whitespace-pre-line">{{ subTitle }}</p>
                        <p class="text-black-800 font-inter text-xl text-center">Please select your state to get started</p>
                    </ng-container>
                </div>
            </ng-container>

            <ng-template #nonEmployee>
                <p class="text-black-800 font-inter-bold text-2xl text-center" *ngIf="!trustedUrl">Please select your state to get started</p>
            </ng-template>

            <div class="my-6 xilo-input__group w-56" *ngIf="!trustedUrl">
                <mat-form-field class="w-full" [floatLabel]="'never'">
                  <mat-select [(ngModel)]="selectedValue"  (selectionChange)="onOptionsSelected($event.value)"
                  placeholder="Select State">
                          <mat-option class="text-base" *ngFor="let state of states" [value]="state.link">
                            {{state?.value}}
                          </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="trustedUrl" class="overflow-y-auto h-full w-full md:w-full">
                <iframe  class="w-full locator-iframe relative" [src]='trustedUrl' title="Assured Partner"></iframe>
            </div>
        </div>
    </div>
</div>
